import React, { useState } from 'react';

import { AppBar, Box, Toolbar, Typography } from '@mui/material';
    
import LoginModal from '../modals/LoginModal';
import SignUpModal from '../modals/SignUpModal';

import Drawer from '../UI/Drawer';

export default function PageAppBar() {
  const [loginOpen, setLoginOpen] = useState(false);
  const handleLoginOpen = () => setLoginOpen(true);
  const handleLoginClose = () => setLoginOpen(false);
  const [signUpOpen, setSignUpOpen] = useState(false);
  const handleSignUpOpen = () => setSignUpOpen(true);
  const handleSignUpClose = () => setSignUpOpen(false);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed">
        <Toolbar>
          <Drawer />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            ORJUPOL
          </Typography>
          <LoginModal 
            loginOpen={loginOpen}
            handleLoginOpen={handleLoginOpen}
            handleLoginClose={handleLoginClose}
            signUpOpen={signUpOpen}
            handleSignUpOpen={handleSignUpOpen}
            handleSignUpClose={handleSignUpClose}
          />
          <SignUpModal 
            signUpOpen={signUpOpen}
            handleSignUpClose={handleSignUpClose}
            handleLoginOpen={handleLoginOpen}
          />
        </Toolbar>
      </AppBar>
    </Box>
  );
}
